import React, {useEffect, useRef, useState} from "react";
import {useGLTF} from '@react-three/drei/core/useGLTF';
import * as THREE from 'three';
import {Environment} from "drei";
import {Plane, Sky, Loader} from "@react-three/drei";

export default function House(props) {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [modelPath, setModelPath] = useState([]);

    useEffect(() => {
        fetch(`https://blue7.it/presentation/beta3/configurator3d.php?ho_id=${props.id}&house=${props.house}`)
            .then(res => res.json())
            .then(
                (result) => {
                    setIsLoaded(true);
                    setModelPath(result.model_path);
                },

                (error) => {
                    setIsLoaded(true);
                    setError(error);
                }
            )
    }, [])


    const group = useRef();
    const {nodes, materials} = useGLTF(modelPath);


    const colors = {
        roofTiles: props.roofColor,
        gutters: props.guttersColor,
        walls: props.wallsColor,
        wallsSecond: props.wallsSecondColor,
        windows: props.windowsColor,
        doors: props.doorColor,
    }

    // console.log(nodes)



    if (isLoaded) {


        return (



            <group ref={group} dispose={null} position={[0, -3, 0]}>


                <Plane receiveShadow rotation-x={-Math.PI / 2} position={[0, -0.5, 0]} args={[1000, 1000]} material-color={'#C4c4c4'}/>

                {/*<Environment path={"https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/Park2/"} files={['posx.jpg', 'negx.jpg', 'posy.jpg', 'negy.jpg', 'posz.jpg', 'negz.jpg']} preset={null} background={false} />*/}
                {/*<Environment path={"https://raw.githubusercontent.com/mrdoob/three.js/master/examples/textures/cube/pisa/"} files={['px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png']} preset={null} background={false} />*/}
                {/*<Sky distance={450000} sunPosition={[0, 1, 0]} inclination={0} azimuth={0.25}/>*/}
                {
                    nodes !== undefined && nodes.roof_tiles !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.roof_tiles} material-color={colors.roofTiles}
                          geometry={nodes.roof_tiles.geometry}/>
                }


                {
                    nodes !== undefined && nodes.walls_outside_1f_top !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.walls_outside_1f_top.geometry}/>
                }


                {
                    nodes !== undefined && nodes.walls_outside_attic_top !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.walls_outside_attic_top.geometry}/>
                }


                {
                    nodes !== undefined && nodes.walls_outside_roof !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.walls_outside_roof.geometry}/>
                }


                {
                    nodes !== undefined && nodes.walls_outside_attic !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.walls_outside_attic.geometry}/>
                }


                {
                    nodes !== undefined && nodes.walls_outside_1f !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.walls_outside_1f.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_inside_1f_top !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside} geometry={nodes.walls_inside_1f_top.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_inside_attic_top !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside}
                          geometry={nodes.walls_inside_attic_top.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_inside_roof !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside} geometry={nodes.walls_inside_roof.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_inside_attic !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside} geometry={nodes.walls_inside_attic.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_inside_1f !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside} geometry={nodes.walls_inside_1f.geometry}/>
                }

                {
                    nodes !== undefined && nodes.ceiling_outside !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls} material-color={colors.walls}
                          geometry={nodes.ceiling_outside.geometry}/>
                }

                {
                    nodes !== undefined && nodes.ceiling_inside !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.walls_inside} geometry={nodes.ceiling_inside.geometry}/>
                }

                {
                    nodes !== undefined && nodes.walls_second !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.wall_second} material-color={colors.wallsSecond}
                          geometry={nodes.walls_second.geometry}/>
                }

                {
                    nodes !== undefined && nodes.window_frame_1f !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.plastic_white} material-color={colors.windows}
                          geometry={nodes.window_frame_1f.geometry}/>
                }

                {/*Doors*/}
                {/*DSP_004*/}
                {
                    props.activeDoor === 'dsp_002' && nodes !== undefined && nodes.door_entrance_panel_dsp_002 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.plastic_door} material-color={colors.doors}
                              geometry={nodes.door_entrance_panel_dsp_002.geometry}/>
                }


                {/*DSP_004*/}
                {
                    props.activeDoor === 'dsp_004' && nodes !== undefined && nodes.door_entrance_panel_dsp_004 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.plastic_door} material-color={colors.doors}
                              geometry={nodes.door_entrance_panel_dsp_004.geometry}/>
                }

                {
                    props.activeDoor === 'dsp_004' && nodes !== undefined && nodes.door_entrance_glass_dsp_004 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.door_entrance_glass_dsp_004.geometry}/>
                }

                {/*DSP_008*/}
                {
                    props.activeDoor === 'dsp_008' && nodes !== undefined && nodes.door_entrance_panel_dsp_008 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.plastic_door} material-color={colors.doors}
                              geometry={nodes.door_entrance_panel_dsp_008.geometry}/>
                }

                {
                    props.activeDoor === 'dsp_008' && nodes !== undefined && nodes.door_entrance_glass_dsp_008 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.door_entrance_glass_dsp_008.geometry}/>
                }


                {/*DSP_010*/}
                {
                    props.activeDoor === 'dsp_010' && nodes !== undefined && nodes.door_entrance_panel_dsp_010 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.plastic_door} material-color={colors.doors}
                              geometry={nodes.door_entrance_panel_dsp_010.geometry}/>
                }

                {
                    props.activeDoor === 'dsp_010' && nodes !== undefined && nodes.door_entrance_glass_dsp_010 !== undefined &&
                        <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.door_entrance_glass_dsp_010.geometry}/>
                }


                {
                    nodes !== undefined && nodes.window_frame_attic !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.plastic_white} material-color={colors.windows}
                          geometry={nodes.window_frame_attic.geometry}/>
                }

                {
                    nodes !== undefined && nodes.gutters !== undefined &&
                    <mesh castShadow={true}  receiveShadow={true} material={materials.metal} material-color={colors.gutters} geometry={nodes.gutters.geometry}/>
                    // <mesh castShadow={true} receiveShadow={true} material={new THREE.MeshPhysicalMaterial({metalness:0.9, roughness:0.1, reflectivity:0.1} )} material-color={colors.gutters} geometry={nodes.gutters.geometry}/>
                    // <mesh castShadow=true  receiveShadow={true} material={new THREE.Mesh castShadow=trueP receiveShadow={true} hysicalMaterial({metalness:0.1, roughness:0.2})} material-color={"#000000"} geometry={nodes.gutters.geometry}/>
                }

                {
                    nodes !== undefined && nodes.roof_base_wood !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.wood} geometry={nodes.roof_base_wood.geometry}/>
                }

                {
                    nodes !== undefined && nodes.door_entrance_handel !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.metal_handel} geometry={nodes.door_entrance_handel.geometry}/>
                }

                {
                    nodes !== undefined && nodes.window_glass_roof !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.window_glass_roof.geometry}/>
                }

                {
                    nodes !== undefined && nodes.wood_floor_1f !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.wood_floor} geometry={nodes.wood_floor_1f.geometry}/>
                }

                {
                    nodes !== undefined && nodes.terrace_floor !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.wood} geometry={nodes.terrace_floor.geometry}/>
                }

                {
                    nodes !== undefined && nodes.wood_floor_attic !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.wood_floor} geometry={nodes.wood_floor_attic.geometry}/>
                }

                {
                    nodes !== undefined && nodes.step_floor !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.tiles_sidewalk} geometry={nodes.step_floor.geometry}/>
                }

                {
                    nodes !== undefined && nodes.basement !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.concrete} geometry={nodes.basement.geometry}/>
                }


                {
                    nodes !== undefined && nodes.window_frame_roof !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.plastic_anthrazit} geometry={nodes.window_frame_roof.geometry}/>
                }

                {
                    nodes !== undefined && nodes.window_glass_1f !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.window_glass_1f.geometry}/>
                }

                {
                    nodes !== undefined && nodes.window_glass_attic !== undefined &&
                    <mesh castShadow={true} receiveShadow={true} material={materials.glass} geometry={nodes.window_glass_attic.geometry}/>
                }


            </group>
        )
    } else {
        return <group>
        </group>
    }
}
